var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_78",
    "data-name": "Group 78",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.62,
    height: 20.761,
    viewBox: "0 0 21.62 20.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(3.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M126.474,0a5.474,5.474,0,1,0,5.474,5.474A5.48,5.48,0,0,0,126.474,0Z",
    transform: "translate(-121)",
    fill: "#4599ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(0 12.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M46.934,302.36A7.8,7.8,0,0,0,41.34,300H38.907a7.8,7.8,0,0,0-5.594,2.36A7.978,7.978,0,0,0,31,307.988a.608.608,0,0,0,.608.608h17.03a.608.608,0,0,0,.608-.608A7.978,7.978,0,0,0,46.934,302.36Z",
    transform: "translate(-31 -300)",
    fill: "#4599ff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "price-tag",
    transform: "translate(15.49 7.116) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M5.492,0H3.871a1.142,1.142,0,0,0-.813.337L.218,3.177a.744.744,0,0,0,0,1.052L1.9,5.913a.744.744,0,0,0,1.052,0L5.793,3.071a1.141,1.141,0,0,0,.337-.813V.639A.639.639,0,0,0,5.492,0ZM4.725,2.043A.639.639,0,1,1,5.364,1.4.639.639,0,0,1,4.725,2.043Z",
    fill: "#4599ff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.ad4ebcb69a153b64be0bbfe79ffafdf2.svg";
export { ForwardRef as ReactComponent };